import { RunningExperiments, useExperiments } from 'state/experiments';

export const useValidateCCNumberInClientExperiment = () => {
  const { variant } = useExperiments();

  return variant(RunningExperiments.ValidateCCNumberInClient, 'treatment');
};
